export default "__VITE_ASSET__o8DETUD5__"